import { OneOrManySchema } from 'notable-common';
import { z } from 'zod';
import { FlowKind, FlowState } from './enums.js';
import { FlowTagInputsSchema, FlowTagNameSchema } from './tags.js';
import { FlowDefinitionState } from '../flowDefinition/flowDefinition.js';
export var FlowOrderByFieldName;
(function (FlowOrderByFieldName) {
    FlowOrderByFieldName["Name"] = "name";
    FlowOrderByFieldName["State"] = "state";
    FlowOrderByFieldName["Description"] = "description";
    FlowOrderByFieldName["Created"] = "created";
    FlowOrderByFieldName["Updated"] = "updated";
    FlowOrderByFieldName["CreatedByEmail"] = "createdByEmail";
    FlowOrderByFieldName["AgentName"] = "agentName";
    FlowOrderByFieldName["AgentId"] = "agentId";
})(FlowOrderByFieldName || (FlowOrderByFieldName = {}));
const FlowOrderByFieldNameSchema = z.enum(FlowOrderByFieldName);
const FlowOrderByFieldWithDirectionSchema = z.object({
    field: FlowOrderByFieldNameSchema,
    direction: z.enum(['asc', 'desc']).default('asc'),
});
export const FlowFindAllQueryParamsSchema = z.object({
    q: z.string().optional(),
    name: z.string().optional(),
    slug: OneOrManySchema(z.string()).optional(),
    ids: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    organizationId: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    agentId: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    state: z.enum(FlowState).optional(),
    kind: z.enum(FlowKind).optional(),
    includeInvisible: z.coerce.boolean().default(false).optional(),
    createdBefore: z.coerce.date().optional(),
    createdAfter: z.coerce.date().optional(),
    createdByEmail: z.string().optional(),
    includeEmails: z.coerce.boolean().optional(),
    includesSubFlowDefinitionId: z.uuid().optional(),
    includeTags: z.coerce.boolean().default(false).optional(),
    tags: z.union([z.array(FlowTagNameSchema), FlowTagNameSchema, FlowTagInputsSchema]).optional(),
    includeFlowDefinitionStates: z.coerce.boolean().default(false).optional(),
    flowDefinitionStates: OneOrManySchema(z.string()).optional(),
    limit: z.coerce.number().optional(),
    offset: z.coerce.number().optional(),
    orderBy: z
        .union([
        // FlowOrderByFieldNameSchema is the old format (string) for backward compatibility
        // will be removed once frontend is updated to use the new format
        OneOrManySchema(FlowOrderByFieldNameSchema),
        OneOrManySchema(FlowOrderByFieldWithDirectionSchema),
    ])
        .optional(),
    // This is not needed anymore, but keeping it for backward compatibility with FlowOrderByFieldNameSchema
    // will be removed once frontend is updated to use the new format
    orderDirection: z.enum(['asc', 'desc']).optional(),
});
/**
 * Path params for the routes addressing one flow: get and update.
 *
 * Named for what it carries rather than for either route, since both use it.
 */
export const FlowIdParamsSchema = z.strictObject({ id: z.uuid() });
export const GetFlowByIdQueryParamsSchema = z.object({
    flowDefinitionLimit: z.coerce
        .number()
        .int()
        .positive()
        .describe('Maximum number of flow definition metadata records to return.')
        .optional(),
    flowDefinitionOrderDirection: z
        .enum(['asc', 'desc'])
        .describe('Order flow definition metadata by version, ascending or descending.')
        .optional(),
});
export const FlowSkillsFindAllQueryParamsSchema = z.object({
    q: z.string().optional(),
    name: z.string().optional(),
    slug: z.string().optional(),
    ids: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    organizationId: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    agentId: z.union([z.array(z.uuid()), z.uuid()]).optional(),
    state: z.enum(FlowState).optional(),
    kind: z.enum(FlowKind).optional(),
    createdBefore: z.coerce.date().optional(),
    createdAfter: z.coerce.date().optional(),
    createdByEmail: z.string().optional(),
    includeTags: z.coerce.boolean().default(false).optional(),
    tags: z.union([z.array(FlowTagNameSchema), FlowTagNameSchema]).optional(),
    flowDefinitionStates: OneOrManySchema(z.enum(FlowDefinitionState)).optional(),
    limit: z.coerce.number().optional(),
    offset: z.coerce.number().optional(),
    orderBy: OneOrManySchema(FlowOrderByFieldWithDirectionSchema).optional(),
});
//# sourceMappingURL=flowRequests.js.map